import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import pathLanguageDetector from './pathLanguageDetector';
import { getLocaleFromPathname, DEFAULT_LOCALE } from './routing';
import { loadLocaleBundle, isLocaleBundleLoaded } from './loadLocaleBundle';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(pathLanguageDetector);

let initPromise = null;

export function getInitialLocale() {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }
  return getLocaleFromPathname(window.location.pathname);
}

export async function initI18n() {
  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    const initialLocale = getInitialLocale();

    if (!i18n.isInitialized) {
      await i18n
        .use(languageDetector)
        .use(initReactI18next)
        .init({
          resources: {},
          lng: initialLocale,
          fallbackLng: DEFAULT_LOCALE,
          supportedLngs: (process.env.REACT_APP_SUPPORTED_LANGUAGES || 'fr,en').split(','),
          detection: {
            order: ['path', 'localStorage', 'navigator'],
            caches: ['localStorage'],
          },
          interpolation: {
            escapeValue: false,
          },
          react: {
            useSuspense: false,
          },
        });
    }

    await loadLocaleBundle(initialLocale);

    i18n.on('languageChanged', (lng) => {
      if (!isLocaleBundleLoaded(lng)) {
        loadLocaleBundle(lng);
      }
    });

    return i18n;
  })();

  return initPromise;
}

export default i18n;
